<template>
  <div class="trabalhe-conosco-form">
    <form @submit.prevent="enviarFormulario">
      <div class="row g-3">
        <div class="col-md-6">
          <label for="nome" class="form-label">Nome Completo *</label>
          <input type="text" class="form-control" id="nome" v-model="formData.nome" required>
        </div>
        <div class="col-md-6">
          <label for="email" class="form-label">E-mail *</label>
          <input type="email" class="form-control" id="email" v-model="formData.email" required>
        </div>
        <div class="col-md-6">
          <label for="telefone" class="form-label">Telefone *</label>
          <input type="tel" class="form-control" id="telefone" v-model="formData.telefone" required>
        </div>
        <div class="col-md-6">
          <label for="cargo" class="form-label">Cargo de Interesse *</label>
          <input type="text" class="form-control" id="cargo" v-model="formData.cargo" required>
        </div>
        <div class="col-12">
          <label for="curriculo" class="form-label">Currículo (PDF) *</label>
          <input type="file" class="form-control" id="curriculo" @change="handleFileUpload" accept=".pdf">
          <small class="text-muted">Tamanho máximo: 5MB</small>
        </div>
        <div class="col-12">
          <label for="mensagem" class="form-label">Mensagem Adicional</label>
          <textarea class="form-control" id="mensagem" v-model="formData.mensagem" rows="4"></textarea>
        </div>
      </div>
      <div class="mt-4">
        <button type="submit" class="btn btn-primary" :disabled="enviando">
          <span v-if="enviando" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          {{ enviando ? 'Enviando...' : 'Enviar Currículo' }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'TrabalheConoscoForm',
  data() {
    return {
      enviando: false,
      formData: {
        nome: '',
        email: '',
        telefone: '',
        cargo: '',
        mensagem: '',
        file: null
      }
    }
  },
  methods: {
    async enviarFormulario() {
      this.enviando = true;
      try {
        let fileBase64 = null;
        
        // Converte o arquivo para base64 se existir
        if (this.formData.file) {
          fileBase64 = await this.convertFileToBase64(this.formData.file);
        }

        const response = await fetch('https://hammernaval.com.br/save-contato.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            nome: this.formData.nome,
            email: this.formData.email,
            telefone: this.formData.telefone,
            cargo: this.formData.cargo,
            mensagem: this.formData.mensagem,
            file: fileBase64
          })
        });

        if (!response.ok) {
          throw new Error('Erro ao enviar formulário');
        }

        const data = await response.json();
        alert('Formulário enviado com sucesso!');
        this.resetForm();
      } catch (error) {
        console.error('Erro:', error);
        alert('Erro ao enviar formulário. Por favor, tente novamente.');
      } finally {
        this.enviando = false;
      }
    },
    convertFileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          // Remove o prefixo "data:application/pdf;base64," do resultado
          const base64String = reader.result.split(',')[1];
          resolve(base64String);
        };
        reader.onerror = error => reject(error);
      });
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        if (file.size > 5 * 1024 * 1024) { // 5MB em bytes
          alert('O arquivo é muito grande. O tamanho máximo permitido é 5MB.');
          event.target.value = '';
          return;
        }
        this.formData.file = file;
      }
    },
    resetForm() {
      this.formData = {
        nome: '',
        email: '',
        telefone: '',
        cargo: '',
        mensagem: '',
        file: null
      };
      this.$el.querySelector('form').reset();
    }
  }
}
</script>

<style scoped>
.trabalhe-conosco-form {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
}

.form-label {
  font-weight: 500;
  color: #333;
}

.form-control {
  border-radius: 0.5rem;
  padding: 0.75rem;
  border: 1px solid #ddd;
}

.form-control:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 0.2rem rgba(0, 36, 65, 0.25);
}

.btn-primary {
  padding: 0.75rem 2rem;
  border-radius: 0.5rem;
  font-weight: 500;
  min-width: 200px;
}

.btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.spinner-border {
  width: 1rem;
  height: 1rem;
}

@media (max-width: 768px) {
  .trabalhe-conosco-form {
    padding: 1rem;
  }
}
</style> 